import { createContext } from 'react';

import type { ShiftContextValue } from '../../../types';

const ShiftContext = createContext<ShiftContextValue | undefined>(undefined);

export default ShiftContext;
